import { render, staticRenderFns } from "./top.vue?vue&type=template&id=461527a8&scoped=true"
import script from "./top.vue?vue&type=script&lang=js"
export * from "./top.vue?vue&type=script&lang=js"
import style0 from "./top.vue?vue&type=style&index=0&id=461527a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461527a8",
  null
  
)

export default component.exports